<template>
    <div class="wrapper">
        <div class="header-my" v-if="!isPhone">
            <van-nav-bar title="关于我们" />
        </div>
        <div class="content about">
            <div v-html="companyInfo.content"></div>
        </div>
    </div>
</template>

<script>
    import {getCompanyProfileService} from "../service/untilService";
    import {getUrlParamsTools} from "../util/tools";
	//import {wecharShare} from "../util/weChat.js";
    export default {
        data () {
            return{
                companyInfo:{},
                isPhone:false,
            }
        },
        mounted () {
            const state = getUrlParamsTools('isPhone');
            if(state){
                this.isPhone = true;
            }
            this.getCompanyProfile();
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods : {
            getCompanyProfile(){
                getCompanyProfileService().then(res => {
                    if(res.status === 1){
                        this.companyInfo = res.datas;
                    }else{
                        alert(1)
                    }
                })
            }
        },
        components : {
        },
     }
</script>

<style scoped lang="scss">
    .wrapper{
        background: #ffffff!important;
        .header-my{
            position: fixed;
            width: 100%;
            padding-bottom: 50px;
        }
        .content{
            background: #ffffff!important;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .logo{
                height: 60px;
                width: 60px;
                padding: 10px 0;
                img{
                    width: 100%;
                    height: 100%;
                    /*border-radius: 50%;*/
                }
            }
            .title{
                margin-top: 10px;
                font-size: 16px;
            }
            .company-content{
                margin-top: 10px;
                padding: 0.3125rem 0.5rem;
                box-sizing: border-box;
                text-indent: 24px;
            }
            .info-box{
                .item{
                    margin-top: 10px;
                    .bg-img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .info{
                width: 100%;
            }
            .down-box{
                margin-top: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding-bottom: 100px;
                p{
                    margin-bottom: 10px;
                    font-size: 16px;
                }
                img{
                    width: 60%;
                    height: 60%;
                }
            }
        }
    }
</style>
<style>
    .about img{
        width: 100%;
        height: 100%;
        display: block;
    }
</style>